<template>
  <div
    class="c-invites-not-found"
    :class="{ 'there-arent': thereArentInvites }"
  >
    <base-icon
      class="info-icon"
      width="24"
      height="24"
      name="painel/info-icon"
    />
    <p v-if="thereArentInvites">
      Ops, não encontramos nenhum convite criado. Por favor, entre em contato
      com os responsáveis pelo evento.
    </p>
    <p v-else>
      Não foi possível localizar o nome informado. Tente inserir o nome de algum
      convidado presente neste convite.
    </p>

    <button
      v-if="showAllInvites && !thereArentInvites"
      @click="$emit('showAll')"
      type="button"
      class="link"
    >
      Ver todos os convites
      <base-icon width="12" height="12" name="painel/chevron-left-icon" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    showAllInvites: {
      type: Boolean,
      default: false,
    },
    thereArentInvites: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.c-invites-not-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  padding: 16px;
  border-radius: 8px;
  background-color: rgba(237, 191, 207, 0.2);
  &.there-arent {
    margin-bottom: 0;
  }

  .info-icon {
    color: $error;
  }

  p {
    margin: 8px 0;
    color: $neutral;
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
  }
}
</style>
